<template>
  <div class="satellite-selector">
    <app-sel
      v-model="satellite"
      @input="changeSatellite"
      :items="items"
      key-name="id"
      label-name="name"
      :label="$ml.get('Select satellite')"
    >
      <template v-slot="{ items }">
        <app-sel-opt
          v-for="item in items"
          :value="item"
          :key="item.id"
        >
          {{ item.name }}
        </app-sel-opt>
      </template>
    </app-sel>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      default: 0,
    },
    items: {
      required: true,
    },
  },
  data() {
    return {
      satellite: this.value,
    }
  },
  methods: {
    changeSatellite() {
      this.$store.dispatch('satellite/selectSatellite', this.satellite);
    },
  }

}
</script>

<style lang="scss" scoped>
.satellite-selector {
  padding-top: 16px;
  margin-bottom: 16px;
  margin-top: 16px;
}
</style>
